export default __webpack_public_path__ + "images/fa536ba43f63aa5b96cc2202b409e902-food.webp";